import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VendorEmailService {
  private email: BehaviorSubject<string> = new BehaviorSubject(null);

  public setVendorEmailValue(value: string) {
    this.email.next(value);
  }
  public getVendorEmailValue(): Observable<string> {
    return this.email.asObservable();
  }
}
